export default function RecruitContent() {
  const benefits = [
    {
      icon: 'ri-money-yen-circle-line',
      title: '月給25万円〜',
      description: '経験・能力に応じて優遇いたします',
    },
    {
      icon: 'ri-calendar-check-line',
      title: '週休二日制',
      description: 'プライベートも大切にできる環境です',
    },
    {
      icon: 'ri-arrow-up-circle-line',
      title: '昇給あり',
      description: '頑張りをしっかり評価・還元します',
    },
    {
      icon: 'ri-car-line',
      title: '社用車貸出',
      description: '通勤・業務に社用車をご利用いただけます',
    },
    {
      icon: 'ri-shield-check-line',
      title: '社会保険完備',
      description: '健康保険・厚生年金・雇用保険・労災保険',
    },
    {
      icon: 'ri-time-line',
      title: 'フレックスタイム導入',
      description: '柔軟な働き方で効率的に業務を進められます',
    },
  ];

  const positions = [
    {
      title: '営業職',
      image: 'https://public.readdy.ai/ai/img_res/eafa0fed0ac8650a89f018d91d556446.jpg',
      details: [
        { label: '仕事内容', value: '賃貸管理会社・不動産オーナー様への提案営業、既存顧客のフォロー、見積作成など' },
        { label: '応募資格', value: '普通自動車免許（AT限定可）、未経験歓迎' },
        { label: '勤務地', value: '大阪市住吉区（大阪・神戸・京都エリア）' },
        { label: '勤務時間', value: '8:30〜17:30' },
      ],
    },
    {
      title: '現場職人',
      image: 'https://readdy.ai/api/search-image?query=skilled%20Japanese%20craftsman%20in%20clean%20work%20uniform%20performing%20professional%20interior%20renovation%20work%20in%20bright%20modern%20apartment%20room%20house%20cleaning%20and%20restoration%20Japanese%20worker%20with%20attention%20to%20detail%20warm%20natural%20lighting&width=600&height=400&seq=recruit-worker-jp-1&orientation=landscape',
      details: [
        { label: '仕事内容', value: 'ハウスクリーニング、クロス張替え、床張替え、原状回復工事の施工作業' },
        { label: '応募資格', value: '経験者優遇・未経験者も丁寧に指導いたします' },
        { label: '勤務地', value: '大阪市住吉区（大阪・神戸・京都エリア）' },
        { label: '勤務時間', value: '8:30〜17:30' },
      ],
    },
  ];

  return (
    <section className="py-12 sm:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        {/* Introduction */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            一緒に働く仲間を募集しています
          </h2>
          <p className="text-xs sm:text-sm text-gray-500 tracking-widest uppercase mb-6 sm:mb-8">RECRUIT</p>
          <p className="text-sm sm:text-base text-gray-700 leading-relaxed max-w-3xl mx-auto">
            Refresh Laboでは事業拡大に伴い、営業職および現場職人を正社員として積極採用中です。
            未経験の方も歓迎！充実した待遇と働きやすい環境で、あなたの成長を全力でサポートします。
          </p>
        </div>

        {/* Benefits */}
        <div className="mb-14 sm:mb-20">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-8 sm:mb-10">
            待遇・福利厚生
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {benefits.map((item) => (
              <div
                key={item.title}
                className="bg-gray-50 rounded-lg p-5 sm:p-6 flex items-start gap-4 hover:shadow-md transition-shadow"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full bg-teal-100 text-teal-600 flex-shrink-0">
                  <i className={`${item.icon} text-xl sm:text-2xl`}></i>
                </div>
                <div>
                  <p className="text-sm sm:text-base font-bold text-gray-900 mb-1">{item.title}</p>
                  <p className="text-xs sm:text-sm text-gray-600">{item.description}</p>
                </div>
              </div>
            ))}
            <div className="bg-gray-50 rounded-lg p-5 sm:p-6 flex items-start gap-4 hover:shadow-md transition-shadow">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full bg-teal-100 text-teal-600 flex-shrink-0">
                <i className="ri-chat-smile-3-line text-xl sm:text-2xl"></i>
              </div>
              <div>
                <p className="text-sm sm:text-base font-bold text-gray-900 mb-1">その他</p>
                <p className="text-xs sm:text-sm text-gray-600">詳細は面接にて要相談</p>
              </div>
            </div>
          </div>
        </div>

        {/* Positions */}
        <div>
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-8 sm:mb-10">
            募集職種
          </h3>
          <div className="space-y-8 sm:space-y-10">
            {positions.map((pos) => (
              <div
                key={pos.title}
                className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow"
              >
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div className="w-full h-56 sm:h-64 md:h-auto">
                    <img
                      src={pos.image}
                      alt={pos.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-5 sm:p-8">
                    <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-6 flex items-center gap-2">
                      <a href="#recruit-form" className="hover:text-teal-600 transition-colors cursor-pointer">
                        {pos.title}
                      </a>
                    </h4>
                    <div className="space-y-3 sm:space-y-4">
                      {pos.details.map((d) => (
                        <div key={d.label}>
                          <p className="text-xs font-bold text-teal-600 mb-0.5">{d.label}</p>
                          <p className="text-xs sm:text-sm text-gray-700">{d.value}</p>
                        </div>
                      ))}
                    </div>
                    <div className="mt-5 sm:mt-6">
                      <a
                        href="#recruit-form"
                        className="inline-block px-6 py-2.5 bg-teal-600 text-white text-sm font-bold rounded-md hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        この職種に応募する
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Note */}
        <div className="mt-10 sm:mt-14 bg-amber-50 border border-amber-200 rounded-lg p-5 sm:p-6">
          <div className="flex items-start gap-3">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-amber-600 text-lg"></i>
            </div>
            <div>
              <p className="text-sm font-bold text-amber-800 mb-1">ご応募について</p>
              <p className="text-xs sm:text-sm text-amber-700 leading-relaxed">
                上記以外の詳細条件につきましては、面接時にご相談させていただきます。まずはお気軽にご応募ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
